function setPillsContainerHeight(container) {
    container.css('min-height', container.height());
}

function unsetPillsContainerHeight(container) {
    container.css('min-height', 'unset');
}

export default () => {
    const navPills = $('.nav-pills');
    const container = navPills.parents('.container');
    const activeClass = 'active';

    navPills.find('a').on('mouseover', (e) => {
        e.stopPropagation();

        setPillsContainerHeight(container);

        const thisTarget = $(e.currentTarget);
        const pillID = thisTarget.data('tab');
        const currentPill = $(`.tab-pane${pillID}`);

        navPills.find('a').not(thisTarget).removeClass(activeClass);
        thisTarget.addClass(activeClass);

        container.find('.tab-pane').not(currentPill).removeClass(activeClass);
        currentPill.addClass(activeClass);
    });

    $(window).on('resize', () => {
        if (navPills.length) {
            unsetPillsContainerHeight(container);
        }
    });
};
